module.exports = __webpack_public_path__ + "img/flag-UK.b4c3d80a.png";